const Home = () => import('@/views/home')
const Test = () => import('@/views/test')

const Workspace = () => import('@/views/workspace')

const NoPermissionPage = () => import('@/views/noPermissionPage')

const Account = () => import('@/views/account')
const Login = () => import('@/views/account/Login')

const Auth = () => import('@/views/auth')

const Business = () => import('@/views/business')

const BasisManage = () => import('@/views/business/basis_manage')
const BasisManageCar = () => import('@/views/business/basis_manage/Car')
const BasisManageGas = () => import('@/views/business/basis_manage/Gas')
const BasisManageGasTank = () => import('@/views/business/basis_manage/GasTank')
const BasisManageDepot = () => import('@/views/business/basis_manage/Depot')
const BasisManageDepotTank = () => import('@/views/business/basis_manage/DepotTank')
const BasisManageDriver = () => import('@/views/business/basis_manage/Driver')
const BasisManageDriverIOCard = () => import('@/views/business/basis_manage/DriverIOCard')
const BasisManageCarIOCard = () => import('@/views/business/basis_manage/CarIOCard')
const BasisManageGasDepot = () => import('@/views/business/basis_manage/GasDepot')
const BasisManageGasDistance = () => import('@/views/business/basis_manage/GasDistance')
const BasisManageGasMatch = () => import('@/views/business/basis_manage/GasMatch')
const BasisManageDepotGasWay = () => import('@/views/business/basis_manage/DepotGasWay')
const BasisManageDepotDistance = () => import('@/views/business/basis_manage/DepotDistance')
const BasisManageCompany = () => import('@/views/business/basis_manage/Company')
const BasisManageOilType = () => import('@/views/business/basis_manage/OilType')
const BasisManageGasGroup = () => import('@/views/business/basis_manage/GasGroup')
const BasisManageCarGroup = () => import('@/views/business/basis_manage/CarGroup')
const BasisManageCarRule = () => import('@/views/business/basis_manage/CarRule')
const BasisManageGasRule = () => import('@/views/business/basis_manage/GasRule')
const BasisManageDepotRule = () => import('@/views/business/basis_manage/DepotRule')
const BasisManageDepotDailyOut = () => import('@/views/business/basis_manage/DepotDailyOut')
const BasisManageGasGroupOut = () => import('@/views/business/basis_manage/GasGroupOut')

const StatusData = () => import('@/views/business/status_data')
const StatusDataGasTankStatus = () => import('@/views/business/status_data/gasTankStatus')
const StatusDataDepotLoadTimeDistribution = () => import('@/views/business/status_data/depotLoadTimeDistribution')
const StatusDataReportWarning = () => import('@/views/business/status_data/reportWarning')
const StatusDataGasTankWarning = () => import('@/views/business/status_data/gasTankWarning')
const StatusDataGasTankWarningHome = () => import('@/views/business/status_data/gasTankWarningHome')
const StatusDataHisGasTankWarning = () => import('@/views/business/status_data/HisGasTankWarning')
const StatusDataGasTankError = () => import('@/views/business/status_data/gasTankError')
const StatusDataGasTankOilWarning = () => import('@/views/business/status_data/gasTankOilWarning')
const StatusDataPlanCompared = () => import('@/views/business/status_data/planCompared')
const StatusDataDepotdiff = () => import('@/views/business/status_data/depotdiff')
const StatusDataPlanProgress = () => import('@/views/business/status_data/planProgress')
const StatusDataGasTankWarningMap = () => import('@/views/business/status_data/gasTankWarningMap')
const StatusDataEmptyTank = () => import('@/views/business/status_data/emptyTank')
const StatusDataGasPromotion = () => import('@/views/business/status_data/gasPromotion')
const StatusDataCarMonitor = () => import('@/views/business/status_data/carMonitor')
const StatusDataInvoicingWarning = () => import('@/views/business/status_data/invoicingWarning')
const StatusDataGasDispatchStatus = () => import('@/views/business/status_data/gasDispatchStatus')

const StatusDataDepotTankStatus = () => import('@/views/business/status_data/depotTankStatus')
const StatusDataGasSealWarning = () => import('@/views/business/status_data/gasSaleWarning')

const StatusDataCountData = () => import('@/views/business/status_data/countData')
const StatusDataCarCountData = () => import('@/views/business/status_data/carCountData')

const Authority = () => import('@/views/business/authority')
const AuthorityUsers = () => import('@/views/business/authority/Users')
const AuthorityOrgUser = () => import('@/views/business/authority/OrgUser')
const AuthorityRoles = () => import('@/views/business/authority/Roles')
const AuthorityMenus = () => import('@/views/business/authority/Menus')

const Phone = () => import('@/views/phone')
const PhoneInvoicing = () => import('@/views/phone/invoicing')
const PhoneDistribution = () => import('@/views/phone/distribution')

const Assets = () => import('@/views/business/assets')
const AssetsUploadFile = () => import('@/views/business/assets/uploadFile')

const Dispatch = () => import('@/views/business/dispatch')
const DispatchInvoicing = () => import('@/views/business/dispatch/Invoicing')
const DispatchNoInvoicing = () => import('@/views/business/dispatch/noInvoicing')
const DispatchInvoicingCheck = () => import('@/views/business/dispatch/invoicing_check')
const DispatchDistributionWriteoff = () => import('@/views/business/dispatch/distribution_writeoff')
const DispatchGasOrder = () => import('@/views/business/dispatch/gasOrder')
const DispatchGasRouterOrder = () => import('@/views/business/dispatch/gasRouterOrder')
const DispatchGasRouterOrderAdjust = () => import('@/views/business/dispatch/gasRouterOrderAdjust')
const DispatchGasRouterOrderHis = () => import('@/views/business/dispatch/gasRouterOrderHis')
const DispatchGasRouterOrderRecord = () => import('@/views/business/dispatch/gasRouterOrderRecord')
const DispatchPlanOrderEdit = () => import('@/views/business/dispatch/planOrderEdit')
const DispatchCarSign = () => import('@/views/business/dispatch/CarSign')
const DispatchAdjustOrder = () => import('@/views/business/dispatch/adjustOrder')
const DispatchDistribution = () => import('@/views/business/dispatch/distribution')
const DispatchGasDemand = () => import('@/views/business/dispatch/gasDemand')

const ReportChart = () => import('@/views/report_chart')

const Pi = () => import('@/views/business/pi')

// const MapData = () => import('@/views/mapData')
// const MapHome = () => import('@/views/map')
// const MapDp = () => import('@/views/mapDp')
// const MapOnly = () => import('@/views/map/mapOnly')

// const MapView = () => import('@/views/map_view')
// const MapDy = () => import('@/views/map_view/map_dy')
// const MapLs = () => import('@/views/map_view/map_ls')
// const MapCc = () => import('@/views/map_view/map_cc')
// const MapTest = () => import('@/views/map_view/map_test')
const MapFgs = () => import('@/views/map_view/map_fgs')
// const redirectMap = () => import('@/views/map_view/redirect')
// const intranetEnter = () => import('@/views/map_view/intranetEnter')
// const MapDistribution = () => import('@/views/map_view/map_distribution')

const SysTool = () => import('@/views/business/sys_tool')
const CustomerRebates = () => import('@/views/business/sys_tool/CustomerRebates')
const OutPage = () => import('@/views/business/sys_tool/outPage')
const UploadFile = () => import('@/views/business/sys_tool/uploadFile')

// 车辆监控相关页面
const CarView = () => import('@/views/carView/index')
const CarViewImport = () => import('@/views/carView/import')
const CarViewAnalysis = () => import('@/views/carView/analysis')
const CarViewReport = () => import('@/views/carView/report')

// 企业微信
const WeiXinView = () => import('@/views/weixin_view/index')
const WeiXinViewTest = () => import('@/views/weixin_view/test')

const WeiXinBusiness = () => import('@/views/weixin_view/business/index')
const WeiXinBusinessGasList = () => import('@/views/weixin_view/business/gasList')
const WeiXinBusinessGasHome = () => import('@/views/weixin_view/business/gasHome')
const WeiXinBusinessInvoicing = () => import('@/views/weixin_view/business/invoicing')
const WeiXinBusinessDistribution = () => import('@/views/weixin_view/business/distribution')

const WeiXinBusinessMenus = () => import('@/views/weixin_view/business/menus')
const WeiXinBusinessDistributionList = () => import('@/views/weixin_view/business/distributionList')
const WeiXinBusinessCarList = () => import('@/views/weixin_view/business/carList')

const WeiXinBusinessInvoicingCheck = () => import('@/views/weixin_view/business/invoicing_check/index')
const WeiXinBusinessInvoicingWarningCount = () => import('@/views/weixin_view/business/invoicingWarningCount')
const WeiXinBusinessDistributionDetail = () => import('@/views/weixin_view/business/distributionDetail')
const WeiXinBusinessDistributionAssess = () => import('@/views/weixin_view/business/distributionAssess')
const WeiXinBusinessDistributionLoss = () => import('@/views/weixin_view/business/distribution_loss/index')
const WeiXinBusinessInvoicingCheckProcess = () => import('@/views/weixin_view/business/invoicing_check/checkProcess')

// 一次调运
const Yc = () => import('@/views/business/yc')
const YcHome = () => import('@/views/business/yc/YcHome')
const KqHome = () => import('@/views/business/yc/kqHome')
const YcGasDepotPriority = () => import('@/views/business/yc/GasDepotPriority')
const YcGasDepotPriorityDraft = () => import('@/views/business/yc/GasDepotPriorityDraft')
const YcGasDepot = () => import('@/views/business/yc/GasDepot')
const YcGasDepotDraft = () => import('@/views/business/yc/GasDepotDraft')
const YcDepotInvoicing = () => import('@/views/business/yc/DepotInvoicing')
const YcAjistDepotPlan = () => import('@/views/business/yc/AjustDepotPlan')

// 评价
const Assess = () => import('@/views/business/assess')
const AssessDistributionAssess = () => import('@/views/business/assess/distributionAssess')

// 损耗系统
const LossSystem = () => import('@/views/business/loss_system')
const LossSystemDistributionLoss = () => import('@/views/business/loss_system/DistributionLoss')

const fmRouter = {
  routes: [{
    path: '/map',
    name: 'map',
    component: MapFgs
  },
  // {
  //   path: '/redirect_map',
  //   name: 'redirect_map',
  //   component: redirectMap
  // },
  // {
  //   path: '/big_screen',
  //   name: 'big_screen',
  //   component: () => import('@/views/count_view/big_screen')
  // },
  // {
  //   path: '/intranet_enter',
  //   name: 'intranet_enter',
  //   component: intranetEnter
  // },
  {
    path: '/auth',
    name: 'auth',
    component: Auth
  },
  {
    path: '/dispatch_map',
    name: 'dispatch_map',
    component: () => import('@/views/map_view/dispatch_map')
  },
  // {
  //   path: '/weather_map',
  //   name: 'weather_map',
  //   component: () => import('@/views/map_view/weather')
  // },
  // {
  //   path: '/hot_map',
  //   name: 'hot_map',
  //   component: () => import('@/views/map_view/hot')
  // },
  // {
  //   path: '/imap',
  //   name: 'imap',
  //   component: () => import('@/views/map_view/index/index'),
  //   redirect: {
  //     name: 'imap.dispatch'
  //   },
  //   children: [
  //     {path: 'dispatch', name: 'imap.dispatch', component: () => import('@/views/map_view/index/view/dispatch')},
  //     {path: 'warning', name: 'imap.warning', component: () => import('@/views/map_view/index/view/warning')}
  //   ]
  // },
  {
    path: '/count_view',
    name: 'count_view',
    component: () => import('@/views/count_view'),
    redirect: {
      name: 'count_view.dispatch_home'
    },
    children: [{
      path: 'dispatch_home',
      name: 'count_view.dispatch_home',
      component: () => import('@/views/count_view/dispatch_home')
    }]
  },
  // {
  //   path: '/map_distribution',
  //   name: 'map_distribution',
  //   component: MapDistribution
  // },
  {
    path: '/weixin',
    name: 'weixin',
    component: WeiXinView,
    children: [{
      path: 'test',
      name: 'weixin.test',
      component: WeiXinViewTest
    },
    {
      path: 'business',
      name: 'weixin.business',
      component: WeiXinBusiness,
      children: [{
        path: 'gas_list',
        name: 'weixin.business.gas_list',
        component: WeiXinBusinessGasList
      },
      {
        path: 'gas_home',
        name: 'weixin.business.gas_home',
        component: WeiXinBusinessGasHome
      },
      {
        path: 'invoicing',
        name: 'weixin.business.invoicing',
        component: WeiXinBusinessInvoicing
      },
      {
        path: 'distribution',
        name: 'weixin.business.distribution',
        component: WeiXinBusinessDistribution
      },
      {
        path: 'distribution_list',
        name: 'weixin.business.distribution_list',
        component: WeiXinBusinessDistributionList
      },
      {
        path: 'menus',
        name: 'weixin.business.menus',
        component: WeiXinBusinessMenus
      },
      {
        path: 'car_list',
        name: 'weixin.business.car_list',
        component: WeiXinBusinessCarList
      },
      {
        path: 'invoicing_check',
        name: 'weixin.business.invoicing_check',
        component: WeiXinBusinessInvoicingCheck
      },
      {
        path: 'invoicing_check_process',
        name: 'weixin.business.invoicing_check_process',
        component: WeiXinBusinessInvoicingCheckProcess
      },
      {
        path: 'invoicing_warning_count',
        name: 'weixin.business.invoicing_warning_count',
        component: WeiXinBusinessInvoicingWarningCount
      },
      {
        path: 'distribution_detail',
        name: 'weixin.business.distribution_detail',
        component: WeiXinBusinessDistributionDetail
      },
      {
        path: 'distribution_assess',
        name: 'weixin.business.distribution_assess',
        component: WeiXinBusinessDistributionAssess
      },
      {
        path: 'distribution_loss',
        name: 'weixin.business.distribution_loss',
        component: WeiXinBusinessDistributionLoss
      }]
    }]
  },
  // {
  //   path: '/map_ld',
  //   name: 'map_ld',
  //   component: MapTest
  // },
  // {
  //   path: '/map_only',
  //   name: 'map_only',
  //   component: MapOnly
  // },
  // {
  //   path: '/map_home',
  //   name: 'map_home',
  //   component: MapHome
  // },
  // {
  //   path: '/map_dp',
  //   name: 'map_dp',
  //   component: MapDp
  // },
  {
    path: '/phone',
    name: 'phone',
    component: Phone,
    children: [{
      path: 'invoicing',
      name: 'phone.invoicing',
      component: PhoneInvoicing
    },
    {
      path: 'distribution',
      name: 'phone.distribution',
      component: PhoneDistribution
    }]
  },
  // {
  //   path: '/map_view',
  //   name: 'map_view',
  //   component: MapView,
  //   children: [{
  //     path: 'map_dy',
  //     name: 'map_view.map_dy',
  //     component: MapDy
  //   },
  //   {
  //     path: 'map_ls',
  //     name: 'map_view.map_ls',
  //     component: MapLs
  //   },
  //   {
  //     path: 'map_cc',
  //     name: 'map_view.map_cc',
  //     component: MapCc
  //   },
  //   {
  //     path: 'map_test',
  //     name: 'map_view.map_test',
  //     component: MapTest
  //   }]
  // },
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/test',
    name: 'test',
    component: Test
  },
  {
    path: '/no_permission_page',
    name: 'no_permission_page',
    component: NoPermissionPage
  },
  {
    path: '/workspace',
    name: 'workspace',
    component: Workspace,
    children: [{
      path: 'adjust_order',
      name: 'workspace.adjust_order',
      component: DispatchAdjustOrder
    },
    {
      path: 'pi',
      name: 'workspace.pi',
      component: Pi
    },
    {
      path: 'customer_rebates',
      name: 'workspace.customer_rebates',
      component: CustomerRebates
    },
    {
      path: 'invoicing_check',
      name: 'workspace.invoicing_check',
      component: DispatchInvoicingCheck
    },
    {
      path: 'distribution_writeoff',
      name: 'workspace.distribution_writeoff',
      component: DispatchDistributionWriteoff
    }]
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    redirect: {
      name: 'account.login'
    },
    children: [{
      path: 'login',
      name: 'account.login',
      component: Login
    }]
  },
  {
    path: '/report_chart',
    name: 'report_chart',
    component: ReportChart
  },
  {
    path: '/business',
    name: 'business',
    component: Business,
    children: [{
      path: 'out_page',
      name: 'business.out_page',
      component: OutPage
    },
    {
      path: 'upload_file',
      name: 'upload_file',
      component: UploadFile
    },
    {
      path: 'sys_tool',
      name: 'business.sys_tool',
      component: SysTool,
      children: [{
        path: 'customer_rebates',
        name: 'business.sys_tool.customer_rebates',
        component: CustomerRebates
      }]
    },
    {
      path: 'yc',
      name: 'business.yc',
      component: Yc,
      children: [{
        path: 'yc_home',
        name: 'business.yc.yc_home',
        component: YcHome
      },
      {
        path: 'kq_home',
        name: 'business.yc.kq_home',
        component: KqHome
      },
      {
        path: 'gas_depot_priority',
        name: 'business.yc.gas_depot_priority',
        component: YcGasDepotPriority
      },
      {
        path: 'gas_depot_priority_draft',
        name: 'business.yc.gas_depot_priority_draft',
        component: YcGasDepotPriorityDraft
      },
      {
        path: 'gas_depot',
        name: 'business.yc.gas_depot',
        component: YcGasDepot
      },
      {
        path: 'gas_depot_draft',
        name: 'business.yc.gas_depot_draft',
        component: YcGasDepotDraft
      },
      {
        path: 'depot_invoicing',
        name: 'business.yc.depot_invoicing',
        component: YcDepotInvoicing
      },
      {
        path: 'ajust_depot_plan',
        name: 'business.yc.ajust_depot_plan',
        component: YcAjistDepotPlan
      }]
    },
    {
      path: 'assess',
      name: 'business.assess',
      component: Assess,
      children: [{
        path: 'distribution_assess',
        name: 'business.assess.distribution_assess',
        component: AssessDistributionAssess
      },
      {
        path: 'report_on_time_rate',
        name: 'business.assess.report_on_time_rate',
        component: () => import('@/views/business/assess/reportOnTimeRate')
      },
      {
        path: 'report_error',
        name: 'business.assess.report_error',
        component: () => import('@/views/business/assess/reportError')
      },
      {
        path: 'sys_report',
        name: 'business.assess.sys_report',
        component: () => import('@/views/business/assess/sysReport')
      },
      {
        path: 'deal_on_time',
        name: 'business.assess.deal_on_time',
        component: () => import('@/views/business/assess/dealOnTime')
      },
      {
        path: 'load_on_time_rate',
        name: 'business.assess.load_on_time_rate',
        component: () => import('@/views/business/assess/loadOnTimeRate')
      },
      {
        path: 'in_on_time',
        name: 'business.assess.in_on_time',
        component: () => import('@/views/business/assess/inOnTime')
      },
      {
        path: 'sign_on_time_rate',
        name: 'business.assess.sign_on_time_rate',
        component: () => import('@/views/business/assess/signOnTimeRate')
      },
      {
        path: 'sign_rate',
        name: 'business.assess.sign_rate',
        component: () => import('@/views/business/assess/signRate')
      }]
    },
    {
      path: 'loss_system',
      name: 'business.loss_system',
      component: LossSystem,
      children: [{
        path: 'distribution',
        name: 'business.loss_system.distribution_loss',
        component: LossSystemDistributionLoss
      }]
    },
    {
      path: 'assets',
      name: 'business.assets',
      component: Assets,
      children: [{
        path: 'upload_file',
        name: 'business.assets.upload_file',
        component: AssetsUploadFile
      }]
    },
    {
      path: 'basis_manage',
      name: 'business.basis_manage',
      component: BasisManage,
      children: [{
        path: 'car',
        name: 'business.basis_manage.car',
        component: BasisManageCar
      },
      {
        path: 'gas',
        name: 'business.basis_manage.gas',
        component: BasisManageGas
      },
      {
        path: 'gastank',
        name: 'business.basis_manage.gastank',
        component: BasisManageGasTank
      },
      {
        path: 'depot',
        name: 'business.basis_manage.depot',
        component: BasisManageDepot
      },
      {
        path: 'depot_tank',
        name: 'business.basis_manage.depot_tank',
        component: BasisManageDepotTank
      },
      {
        path: 'driver',
        name: 'business.basis_manage.driver',
        component: BasisManageDriver
      },
      {
        path: 'driver_io_card',
        name: 'business.basis_manage.driver_io_card',
        component: BasisManageDriverIOCard
      },
      {
        path: 'car_io_card',
        name: 'business.basis_manage.car_io_card',
        component: BasisManageCarIOCard
      },
      {
        path: 'gas_depot',
        name: 'business.basis_manage.gas_depot',
        component: BasisManageGasDepot
      },
      {
        path: 'gas_distance',
        name: 'business.basis_manage.gas_distance',
        component: BasisManageGasDistance
      },
      {
        path: 'gas_match',
        name: 'business.basis_manage.gas_match',
        component: BasisManageGasMatch
      },
      {
        path: 'gas_tank_match',
        name: 'business.basis_manage.gas_tank_match',
        component: () => import('@/views/business/basis_manage/GasTankMatch')
      },
      {
        path: 'depot_gas_way',
        name: 'business.basis_manage.depot_gas_way',
        component: BasisManageDepotGasWay
      },
      {
        path: 'depot_distance',
        name: 'business.basis_manage.depot_distance',
        component: BasisManageDepotDistance
      },
      {
        path: 'company',
        name: 'business.basis_manage.company',
        component: BasisManageCompany
      },
      {
        path: 'oil_type',
        name: 'business.basis_manage.oil_type',
        component: BasisManageOilType
      },
      {
        path: 'gas_group',
        name: 'business.basis_manage.gas_group',
        component: BasisManageGasGroup
      },
      {
        path: 'car_group',
        name: 'business.basis_manage.car_group',
        component: BasisManageCarGroup
      },
      {
        path: 'car_rule',
        name: 'business.basis_manage.car_rule',
        component: BasisManageCarRule
      },
      {
        path: 'gas_rule',
        name: 'business.basis_manage.gas_rule',
        component: BasisManageGasRule
      },
      {
        path: 'depot_rule',
        name: 'business.basis_manage.depot_rule',
        component: BasisManageDepotRule
      },
      {
        path: 'depot_daily_out',
        name: 'business.basis_manage.depot_daily_out',
        component: BasisManageDepotDailyOut
      },
      {
        path: 'gas_group_out',
        name: 'business.basis_manage.gas_group_out',
        component: BasisManageGasGroupOut
      }]
    },
    {
      path: 'status_data',
      name: 'business.status_data',
      component: StatusData,
      children: [{
        path: 'gas_tank_status',
        name: 'business.status_data.gas_tank_status',
        component: StatusDataGasTankStatus
      },
      {
        path: 'algo',
        name: 'business.status_data.algo',
        component: () => import('@/views/business/status_data/algo')
      },
      {
        path: 'depot_load_time_distribution',
        name: 'business.status_data.depot_load_time_distribution',
        component: StatusDataDepotLoadTimeDistribution
      },
      {
        path: 'gas_tank_warning',
        name: 'business.status_data.gas_tank_warning',
        component: StatusDataGasTankWarning
      },
      {
        path: 'platform_warn',
        name: 'business.status_data.platform_warn',
        component: () => import('@/views/business/status_data/platformWarn')
      },
      {
        path: 'gas_tank_yc_warning',
        name: 'business.status_data.gas_tank_yc_warning',
        component: () => import('@/views/business/status_data/gasTankYcWarning')
      },
      {
        path: 'gas_tank_his_sale_warning',
        name: 'business.status_data.gas_tank_his_sale_warning',
        component: () => import('@/views/business/status_data/gasTankHisSaleWarning')
      },
      {
        path: 'gas_tank_today_sale_warning',
        name: 'business.status_data.gas_tank_today_sale_warning',
        component: () => import('@/views/business/status_data/gasTankTodaySaleWarning')
      },
      {
        path: 'gas_tank_warning_home',
        name: 'business.status_data.gas_tank_warning_home',
        component: StatusDataGasTankWarningHome
      },
      {
        path: 'his_gas_tank_warning',
        name: 'business.status_data.his_gas_tank_warning',
        component: StatusDataHisGasTankWarning
      },
      {
        path: 'gas_tank_error',
        name: 'business.status_data.gas_tank_error',
        component: StatusDataGasTankError
      },
      {
        path: 'gas_tank_oil_warning',
        name: 'business.status_data.gas_tank_oil_warning',
        component: StatusDataGasTankOilWarning
      },
      {
        path: 'plan_progress',
        name: 'business.status_data.plan_progress',
        component: StatusDataPlanProgress
      },
      {
        path: 'car_month_data',
        name: 'business.status_data.car_month_data',
        component: () => import('@/views/business/status_data/carMonthData')
      },
      {
        path: 'plan_compared',
        name: 'business.status_data.plan_compared',
        component: StatusDataPlanCompared
      },
      {
        path: 'depotdiff',
        name: 'business.status_data.depotdiff',
        component: StatusDataDepotdiff
      },
      {
        path: 'report_warning',
        name: 'business.status_data.report_warning',
        component: StatusDataReportWarning
      },
      {
        path: 'empty_tank',
        name: 'business.status_data.empty_tank',
        component: StatusDataEmptyTank
      },
      {
        path: 'gas_promotion',
        name: 'business.status_data.gas_promotion',
        component: StatusDataGasPromotion
      },
      {
        path: 'car_monitor',
        name: 'business.status_data.car_monitor',
        component: StatusDataCarMonitor
      },
      {
        path: 'invoicing_warning',
        name: 'business.status_data.invoicing_warning',
        component: StatusDataInvoicingWarning
      },
      {
        path: 'gas_dispatch_status',
        name: 'business.status_data.gas_dispatch_status',
        component: StatusDataGasDispatchStatus
      },
      {
        path: 'depot_tank_status',
        name: 'business.status_data.depot_tank_status',
        component: StatusDataDepotTankStatus
      },
      {
        path: 'gas_sale_warning',
        name: 'business.status_data.gas_sale_warning',
        component: StatusDataGasSealWarning
      },
      {
        path: 'count_data',
        name: 'business.status_data.count_data',
        component: StatusDataCountData
      },
      {
        path: 'car_count_data',
        name: 'business.status_data.car_count_data',
        component: StatusDataCarCountData
      }]
    },
    {
      path: 'gas_tank_warning_map',
      name: 'business.gas_tank_warning_map',
      component: StatusDataGasTankWarningMap
    },
    {
      path: 'dispatch',
      name: 'business.dispatch',
      component: Dispatch,
      children: [{
        path: 'report_home',
        name: 'business.dispatch.report_home',
        component: () => import('@/views/business/dispatch/reportHome')
      },
      {
        path: 'order_home',
        name: 'business.dispatch.order_home',
        component: () => import('@/views/business/dispatch/orderHome')
      },
      {
        path: 'warning_home',
        name: 'business.dispatch.warning_home',
        component: () => import('@/views/business/dispatch/warningHome')
      },
      {
        path: 'invoicing',
        name: 'business.dispatch.invoicing',
        component: DispatchInvoicing
      },
      {
        path: 'match_parm',
        name: 'business.dispatch.match_parm',
        component: () => import('@/views/business/dispatch/matchParm')
      },
      {
        path: 'no_invoicing',
        name: 'business.dispatch.no_invoicing',
        component: DispatchNoInvoicing
      },
      {
        path: 'gas_order',
        name: 'business.dispatch.gas_order',
        component: DispatchGasOrder
      },
      {
        path: 'gas_router_order',
        name: 'business.dispatch.gas_router_order',
        component: DispatchGasRouterOrder
      },
      {
        path: 'gas_router_order_adjust',
        name: 'business.dispatch.gas_router_order_adjust',
        component: DispatchGasRouterOrderAdjust
      },
      {
        path: 'gas_router_order_his',
        name: 'business.dispatch.gas_router_order_his',
        component: DispatchGasRouterOrderHis
      },
      {
        path: 'gas_router_order_record',
        name: 'business.dispatch.gas_router_order_record',
        component: DispatchGasRouterOrderRecord
      },
      {
        path: 'plan_order_edit',
        name: 'business.dispatch.plan_order_edit',
        component: DispatchPlanOrderEdit
      },
      {
        path: 'car_sign',
        name: 'business.dispatch.car_sign',
        component: DispatchCarSign
      },
      {
        path: 'distribution',
        name: 'business.dispatch.distribution',
        component: DispatchDistribution
      },
      {
        path: 'stock_receipt',
        name: 'business.dispatch.stock_receipt',
        component: () => import('@/views/business/dispatch/stockReceipt')
      },
      {
        path: 'holiday',
        name: 'business.dispatch.holiday',
        component: () => import('@/views/business/dispatch/holiday')
      },
      {
        path: 'year_data',
        name: 'business.dispatch.year_data',
        component: () => import('@/views/business/dispatch/yearData')
      },
      {
        path: 'month_plan',
        name: 'business.dispatch.month_plan',
        component: () => import('@/views/business/dispatch/monthPlan')
      },
      {
        path: 'gas_demand',
        name: 'business.dispatch.gas_demand',
        component: DispatchGasDemand
      }]
    },
    {
      path: 'authority',
      name: 'business.authority',
      component: Authority,
      children: [{
        path: 'users',
        name: 'business.authority.users',
        component: AuthorityUsers
      },
      {
        path: 'org_user',
        name: 'business.authority.org_user',
        component: AuthorityOrgUser
      },
      {
        path: 'menus',
        name: 'business.authority.menus',
        component: AuthorityMenus
      },
      {
        path: 'roles',
        name: 'business.authority.roles',
        component: AuthorityRoles
      }]
    }]
  },
  {
    path: '/carView',
    name: 'carView',
    component: CarView,
    children: [{
      path: 'import',
      name: 'carView.import',
      component: CarViewImport
    },
    {
      path: 'analysis',
      name: 'carView.analysis',
      component: CarViewAnalysis
    },
    {
      path: 'report',
      name: 'carView.report',
      component: CarViewReport
    }]
  }]
}

export default fmRouter



// WEBPACK FOOTER //
// ./src/router/router_data.js